<div mat-dialog-title>Grant user(s) access to roles</div>
<mat-dialog-content class="fx-col fx-gap-20">
  <div class="heading-bold">Roles</div>
  <mat-label>Select the roles that will be assigned to the specified users. Each of the users will get all of the
    selected roles. If the user's email already exists, their roles will be updated. If you specify details for new
    users, they will be registered automatically. All new users will need to reset their password before they are able
    to log in.
  </mat-label>

  <mat-form-field class="full-width">
    <mat-label>Roles</mat-label>
    <mat-chip-grid #chipList>
      @for (role of selectedRoles; track role) {
        <mat-chip-row (removed)="remove(role)" [removable]="true">
          {{ role.label }}
          <button matChipRemove [attr.aria-label]="'remove'">
            <mat-icon class="add-grants-chip-icon">cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
    </mat-chip-grid>
    <input
      placeholder="New role..."
      type="text"
      [matAutocomplete]="auto"
      [formControl]="roleCtrl"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event)"
    />
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
      @for (group of filteredRoleOptions | async; track group) {
        <mat-optgroup [label]="group.moduleGroupName">
          @for (role of group.principleRoles; track role) {
            <mat-option [value]="role">{{ role.label }}</mat-option>
          }
        </mat-optgroup>
      }
    </mat-autocomplete>
    <mat-hint align="start">Select the role(s) that will be granted</mat-hint>
  </mat-form-field>

  <div class="fx-row fx-space-between fx-v-center">
    <div class="heading-bold">{{ formMode === 'multiple' ? 'Users' : 'User' }}</div>
    <mat-button-toggle-group name="addRolesModeSelector"
                             [(ngModel)]="formMode"
                             class="custom-button-toggle-default"
                             (change)="onChangeUsersFormMode($event)">
      <mat-button-toggle value="single">Single</mat-button-toggle>
      <mat-button-toggle value="multiple">Multiple</mat-button-toggle>
      <mat-button-toggle value="self">Self</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <mat-label>Enter the details for the user below. If the user already exists, the email
    will be used to link the new grants to the user. If no user with the email specified
    exists, a new user will automatically be created.
  </mat-label>


  @if (formMode === 'single' || formMode === 'self') {
    <form [formGroup]="userForm" class="fx-col">
      <div class="fx-row full-width fx-gap-10">
        <mat-form-field class="fx-flex-1">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name">
        </mat-form-field>

        <mat-form-field class="fx-flex-1">
          <mat-label>Surname</mat-label>
          <input matInput formControlName="surname">
        </mat-form-field>
      </div>

      <mat-form-field>
        <mat-label>Email</mat-label>
        <input matInput formControlName="email">
        <mat-hint align="start">The email address specified will be used to log in</mat-hint>
      </mat-form-field>
    </form>
  } @else {
    <div class="fx-row-w-100 fx-h-end">
      <button mat-button (click)="addUser()">Add User</button>
    </div>

    <table mat-table [dataSource]="datasource" class="add-users-table">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let userFormGroup">
          <mat-form-field subscriptSizing="dynamic" class="full-width">
            <input matInput [formControl]="userFormGroup.get('name')" placeholder="Firstname...">
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="surname">
        <th mat-header-cell *matHeaderCellDef>Surname</th>
        <td mat-cell *matCellDef="let userFormGroup">
          <mat-form-field subscriptSizing="dynamic" class="full-width">
            <input matInput [formControl]="userFormGroup.get('surname')" placeholder="Surname...">
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let userFormGroup">
          <mat-form-field subscriptSizing="dynamic" class="full-width">
            <input matInput [formControl]="userFormGroup.get('email')" placeholder="Email...">
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let userFormGroup; let i = index" class="actions-cell">
          <button mat-icon-button (click)="removeUser(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['name', 'surname', 'email', 'actions']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['name', 'surname', 'email', 'actions'];"></tr>
    </table>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-flat-button color="primary"
          (click)="onSubmit()" [disabled]="!grantUsersForm.valid">Grant
  </button>
</mat-dialog-actions>
